export default __webpack_public_path__ + "static/media/diagram-green.4e0f61a7.svg";